import React from 'react';
import s from './GamesCompletedModal.module.scss';
import { Portal } from '../../../components';
import { useTranslation } from 'appState';

const GamesCompletedModal: React.FC = () => {
  const lang = useTranslation('GamesCompletedModal');
  return (
    <Portal>
      <div className={s.modalContainer} data-cy='gamesCompletedModal'>
        <div className={s.modal}>
          <div className={s.spinner} role="status" aria-live="polite" />
          <h5>{lang.header}</h5>
          {lang.subHeader && <h6>{lang.subHeader}</h6>}
          <p>{lang.firstParagraph}</p>
          {lang.secondParagraph && <p>{lang.secondParagraph}</p>}
        </div>
      </div>
    </Portal>
  );
};

export default GamesCompletedModal;
